import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OuterHeaderNavigationModule } from '../shared/outer-header-navigation/outer-header-navigation.module';

const routes: Routes = [
  {path: '', component: TermsAndConditionsComponent},
]

@NgModule({
  declarations: [TermsAndConditionsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    OuterHeaderNavigationModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TermsAndConditionsModule { }
